$(document).ready(function () {
  $(".variant-wrapper").each(function () {
    var $variantButton = $(this).find(".variant__button-label").first();
    // Perform an action on each .variant__button-label within its variant-wrapper
    if ($variantButton.length > 0) {
      $variantButton.click();
      // You can add additional actions or logic related to each variant-wrapper here
    } else {
      console.log("No .variant__button-label found in this variant-wrapper");
    }
  });

  $(".accordion-collapse").on("shown.bs.collapse", function (e) {
    var $panel = $(this).closest(".accordion-item");
    var scrollTo = $panel.offset().top - 120;

    $("html,body").animate(
      {
        scrollTop: scrollTo,
      },
      500
    );
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Links marked data-twe-show-email (contact page) keep a visible, plain mailto.
  const links = document.querySelectorAll('a[href^="mailto:"]:not([data-twe-show-email])');
  links.forEach((link) => {
    const originalHref = link.getAttribute("href");
    const email = originalHref.replace("mailto:", "");
    const [user, domain] = email.split("@");
    link.removeAttribute("target");
    link.setAttribute("href", "#");
    link.setAttribute(
      "onclick",
      `window.open('mai'+'lto:'+'${user}'+'@'+'${domain}');return false;`
    );
    if (link.textContent.trim() === email) {
      link.textContent = "Contact us";
    }
  });
});
(function () {
  // Function to apply styles
  function applyGilroyFont() {
    const divElement = document.getElementById(
      "omnisend-embedded-v2-6639ec64fbff0b5b335be59a"
    );
    if (divElement) {
      // Separate headings from other elements
      const headings = divElement.querySelectorAll("h1, h2, h3, h4, h5, h6");
      const otherElements = divElement.querySelectorAll(
        "p, span, label, input, button"
      );

      // Apply the theme heading font to headings
      headings.forEach((element) => {
        element.style.setProperty("font-family", "var(--typeHeaderPrimary), var(--typeHeaderFallback)", "important");
      });

      // Apply the theme body font to other elements
      otherElements.forEach((element) => {
        element.style.setProperty("font-family", "var(--typeBasePrimary), var(--typeBaseFallback)", "important");
      });

      const totalElements = headings.length + otherElements.length;
      if (totalElements > 0) {
        console.log(
          `Updated font-family for ${totalElements} elements (Headings: ${headings.length}, Others: ${otherElements.length})`
        );
        return true; // Success
      }
    }
    return false; // Not ready yet
  }

  // Initial attempt
  if (applyGilroyFont()) {
    return;
  }

  // Set up MutationObserver
  const observer = new MutationObserver((mutations, obs) => {
    if (applyGilroyFont()) {
      obs.disconnect(); // Stop observing once applied
    }
  });

  // Start observing the document body
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Fallback timeout after 15 seconds
  setTimeout(() => {
    observer.disconnect();
    if (
      !document.getElementById("omnisend-embedded-v2-6639ec64fbff0b5b335be59a")
    ) {
      console.error("Div not found after 15 seconds");
    } else if (
      !document.querySelector(
        "#omnisend-embedded-v2-6639ec64fbff0b5b335be59a p, #omnisend-embedded-v2-6639ec64fbff0b5b335be59a span, #omnisend-embedded-v2-6639ec64fbff0b5b335be59a h1, #omnisend-embedded-v2-6639ec64fbff0b5b335be59a h2, #omnisend-embedded-v2-6639ec64fbff0b5b335be59a h3, #omnisend-embedded-v2-6639ec64fbff0b5b335be59a h4, #omnisend-embedded-v2-6639ec64fbff0b5b335be59a h5, #omnisend-embedded-v2-6639ec64fbff0b5b335be59a h6, #omnisend-embedded-v2-6639ec64fbff0b5b335be59a label, #omnisend-embedded-v2-6639ec64fbff0b5b335be59a input, #omnisend-embedded-v2-6639ec64fbff0b5b335be59a button"
      )
    ) {
      console.error("No target elements found in div after 15 seconds");
    }
  }, 15000);
})();

// (() => {
//   // Grab phrases from metaobject output (set by your Liquid snippet)
//   let phrases = window.SEARCH_PLACEHOLDER_PHRASES;

//   // Normalize + sanitize
//   if (typeof phrases === "string") {
//     phrases = phrases.trim() ? [phrases] : [];
//   }
//   if (!Array.isArray(phrases)) phrases = [];
//   phrases = phrases
//     .map(s => (s ?? "").toString().trim())
//     .filter(Boolean);

//   // Fallback if metaobject empty
//   if (phrases.length === 0) {
//     phrases = [
//       "Search: Surron Parts",
//       "Seach: Tuning Kits"
      
//     ];
//   }

//   // Find the input
//   const input =
//     document.querySelector("#HeaderSearchInput") ||
//     document.querySelector(".site-header__search-input");

//   if (!input) return;

//   // Timing (ms)
//   const typeSpeed = 65;
//   const deleteSpeed = 35;
//   const holdAfterType = 1200;
//   const holdAfterDelete = 300;

//   let phraseIndex = 0;
//   let charIndex = 0;
//   let isDeleting = false;
//   let timer = null;
//   let paused = false;

//   const clearTimer = () => {
//     if (timer) clearTimeout(timer);
//     timer = null;
//   };

//   const pause = () => {
//     paused = true;
//     clearTimer();
//   };

//   const resume = () => {
//     // Only animate if user isn't actively typing something
//     if (input.value && input.value.trim().length) return;
//     if (!paused && timer) return; // already running
//     paused = false;
//     clearTimer();
//     tick();
//   };

//   const tick = () => {
//     if (paused) return;

//     const phrase = phrases[phraseIndex] || "";
//     const text = phrase.slice(0, charIndex);
//     input.setAttribute("placeholder", text);

//     if (!isDeleting) {
//       // typing forward
//       if (charIndex < phrase.length) {
//         charIndex++;
//         timer = setTimeout(tick, typeSpeed);
//       } else {
//         isDeleting = true;
//         timer = setTimeout(tick, holdAfterType);
//       }
//     } else {
//       // deleting
//       if (charIndex > 0) {
//         charIndex--;
//         timer = setTimeout(tick, deleteSpeed);
//       } else {
//         isDeleting = false;
//         phraseIndex = (phraseIndex + 1) % phrases.length;
//         timer = setTimeout(tick, holdAfterDelete);
//       }
//     }
//   };

//   // ✅ Keep animating on focus (unless they've typed something)
//   input.addEventListener("focus", () => {
//     if (!input.value || !input.value.trim()) resume();
//   });

//   // ✅ Pause only when the user actually types/pastes/etc.
//   input.addEventListener("input", () => {
//     if (input.value && input.value.trim().length) {
//       pause();
//     } else {
//       // If they cleared the input, resume animation even while focused
//       resume();
//     }
//   });

//   // ✅ If they leave the field empty, continue animating
//   input.addEventListener("blur", () => {
//     if (!input.value || !input.value.trim()) resume();
//   });

//   // ✅ Some browsers fire "search" when clearing via the (x) button
//   input.addEventListener("search", () => {
//     if (!input.value) resume();
//   });

//   // Start
//   resume();
// })();


(function () {
  function forceFullSize(el) {
    // Force width and height to desired values
    el.style.setProperty('width', '100%', 'important');
    el.style.setProperty('max-width', '100%', 'important');
    el.style.setProperty('height', 'auto', 'important');
    el.style.setProperty('max-height', 'none', 'important');
  }

  function init() {
    var el = document.getElementById('inbank-calculator');
    if (!el) return;

    // Apply immediately
    forceFullSize(el);

    // Watch for inline style changes and reapply
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'attributes' && mutations[i].attributeName === 'style') {
          forceFullSize(el);
        }
      }
    });
    obs.observe(el, { attributes: true, attributeFilter: ['style'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  (function () {
    var swiperInstance = null;

    function initHomepageCategoriesSwiper() {
      if (window.innerWidth > 768) return;
      if (swiperInstance) return;

      swiperInstance = new Swiper('#homepage-categories-swiper', {
        slidesPerView: 1.3,
        
        spaceBetween: 20,
        loop: true,
        speed: 600,
        watchOverflow: true,
        allowTouchMove: true,
        resistance: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
      });
    }

    function destroyHomepageCategoriesSwiper() {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }

    function handleResize() {
      if (window.innerWidth <= 768) {
        initHomepageCategoriesSwiper();
      } else {
        destroyHomepageCategoriesSwiper();
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      handleResize();
      window.addEventListener('resize', handleResize);
    });
  })();


})();

// ==========================================
// Stark Varg – centred slick carousels
// Handles EX / MX / SM product templates.
// Runs after all deferred scripts (jQuery + slick) are ready.
// ==========================================
$(document).ready(function () {
  if (!$.fn.slick || !$('[data-slick-center]').length) return;

  // Convert data-lazy → src + native lazy loading.
  // Required because variableWidth + lazyLoad: 'progressive' is incompatible
  // (slides collapse to zero width when images have no dimensions at init time).
  function convertLazyImages($scope) {
    $scope.find('img[data-lazy]').each(function () {
      var $img = $(this);
      $img.attr('src', $img.attr('data-lazy'))
          .attr('loading', 'lazy')
          .removeAttr('data-lazy');
    });
  }
  convertLazyImages($('[data-slick-center] .csfw-track'));

  // Initialise every un-initialised carousel on the page.
  function initCarousels() {
    $('[data-slick-center]').each(function () {
      var $wrap  = $(this);
      var $track = $wrap.find('.csfw-track');
      var $prev  = $wrap.find('.csfw-arrow--prev');
      var $next  = $wrap.find('.csfw-arrow--next');
      var $dots  = $wrap.find('.csfw-dots');

      if (!$track.length || $track.hasClass('slick-initialized')) return;

      // Handle any lazy images injected after the first pass
      convertLazyImages($track);

      $track.slick({
        centerMode    : true,
        variableWidth : true,
        slidesToShow  : 1,
        infinite      : false,
        arrows        : true,
        dots          : true,
        prevArrow     : $prev,
        nextArrow     : $next,
        appendDots    : $dots,
        centerPadding : '0',
        // No lazyLoad — native loading="lazy" handles images instead
        responsive: [
          { breakpoint: 768, settings: { variableWidth: false, centerPadding: '10vw' } }
        ]
      });
    });
  }

  initCarousels();

  // ------------------------------------------
  // Equal-height slides (all breakpoints)
  // ------------------------------------------
  function equalizeSlideHeights($wrap) {
    var $track = $wrap.find('.csfw-track');
    if (!$track.length || !$track.hasClass('slick-initialized')) return;

    var $slides = $track.find('.slick-slide').not('.slick-cloned');

    // Reset before measuring
    $slides.css({ height: '', minHeight: '' });
    $slides.find('.slide-wrapper').css({ height: '', minHeight: '' });

    var maxH = 0;
    $slides.each(function () {
      var h = $(this).outerHeight();
      if (h > maxH) maxH = h;
    });
    if (!maxH) return;

    $slides.css('min-height', maxH + 'px');
    $slides.find('.slide-wrapper').css('min-height', maxH + 'px');

    // Tell slick to recalculate track/slide positions after height change
    $track.slick('setPosition');
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments, ctx = this;
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  // Double rAF: slick adjusts widths in frame 1, we measure in frame 2
  function recalcWrap($wrap) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        equalizeSlideHeights($wrap);
      });
    });
  }

  var recalcAll = debounce(function () {
    $('[data-slick-center]').each(function () {
      recalcWrap($(this));
    });
  }, 150);

  // Slick lifecycle hooks
  $(document).on('init reInit setPosition afterChange', '[data-slick-center] .csfw-track', function (e, slick) {
    recalcWrap($(slick.$slider).closest('[data-slick-center]'));
  });

  // Media load recalc
  $(document).on('load',                          '[data-slick-center] img',   recalcAll);
  $(document).on('loadedmetadata canplaythrough', '[data-slick-center] video', recalcAll);

  // Window resize / orientation change
  $(window).on('resize orientationchange', recalcAll);

  // Initial height pass
  recalcAll();

  // Re-init when Shopify reloads a section (theme editor preview)
  document.addEventListener('shopify:section:load', function () {
    convertLazyImages($('[data-slick-center] .csfw-track'));
    initCarousels();
    recalcAll();
  });
});
